export const throwPermissionError = () => {
  const err = new Error();
  err.code = 404;
  throw err;
};

export const REGISTERED_ROLE_AND_GROUP_NAME = 'Admin';
export const registeredRoleAndGroupError = (t) =>
  t('This name is reserved by Kizen');
